import { ThemeContext } from "@emotion/react";
import { useContext, useState } from "react";
import { TipoSplitEnum } from "../../../../@enums/tipo_split";
import { Button, Checkbox, Chip, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { Delete } from "@mui/icons-material";
import validateNumber from "../../../../helpers/validateInt";
import { AreaAlmacenEnum } from "../../../../@enums/tipo_almacen";


export const ItemReportCuarentena = ({ movimiento, formData, index, item, almacenes, arraySplit, setArraySplit, setMovReporting, ruta }) => {
  const theme = useContext(ThemeContext);
  const [almacenesCuarentena, setAlmacenesCuarentena] = useState([...almacenes]);
  const [restante, setRestante] = useState(movimiento?.existencia_total);

  const changeCantidad = (index, value) => {
    let cant = 0;
    let rest = movimiento?.existencia_total;
    let movimientos = arraySplit;
    let mov = movimiento;
    if (value !== '') {
      cant = parseInt(value);
      movimientos[index].split = []
      if (cant > (mov?.existencia_total + movimientos[index].cantidad)) {
        cant = mov?.existencia_total + movimientos[index].cantidad;
        formData.current[`cantidad_${index}`].value = cant;
        rest = 0;
      } else {
        rest = mov?.existencia_total + (movimientos[index].cantidad - cant)
      }

    } else {
      rest = mov?.existencia_total + movimientos[index].cantidad;
      cant = null
      movimientos[index].split = []
    }
    setRestante(cant);
    if (item?.tipoSplit === TipoSplitEnum.REGULAR) {
      formData.current[`total_contenedores_${index}`].value = null;
    }
    movimientos[index].cantidad = cant;
    movimiento.existencia_total = rest;
    movimientos[index].tipoSplit = cant % 2 !== 0 ? TipoSplitEnum.IRREGULAR : TipoSplitEnum.REGULAR;
    setArraySplit([...movimientos])
    setMovReporting({ ...mov })
  }

  const changeOtherData = (index, name, value) => {
    let movimientos = arraySplit;
    movimientos[index][name] = value;
    if ((name === 'isCuarentena' || name === 'isExterno') && value === false) {
      movimientos[index].defectivo = null;
      movimientos[index].almacen = ruta?.alma_id;
      let almacenes_data = [...almacenesCuarentena];
      let new_alm = { id: ruta?.alma_id, label: ruta?.almacenes?.alma_nombre };
      setAlmacenesCuarentena([...almacenes_data, new_alm]);
    } else if ((name === 'isCuarentena' || name === 'isExterno') && value === true) {
      movimientos[index].almacen = null;
      movimientos[index].defectivo = null;
      let almacenes_data = [...almacenesCuarentena];
      almacenes_data.pop()
      setAlmacenesCuarentena([...almacenes_data]);
    }
    setArraySplit([...movimientos])
  }

  const changeTipoSplit = (index, value) => {
    let array = arraySplit;
    array[index].tipoSplit = value;
    array[index].split = [];
    setRestante(array[index].cantidad)
    setArraySplit([...array])
  };

  const fillDataRegular = (index, value) => {
    let array = arraySplit;
    let contendedores = value;
    let mov = movimiento;
    if (contendedores !== "") {
      let cont = parseInt(contendedores);
      let paquetes = new Array(cont);
      let cociente = Math.floor(array[index].cantidad / cont);
      let residuo = array[index].cantidad % cont;
      paquetes.fill(cociente);
      if (residuo > 0) {
        paquetes.unshift(residuo)
      };
      array[index].split = paquetes;
    } else {
      array[index].split = []
    }
    setMovReporting({ ...mov })
    setArraySplit([...array])
  };

  const fillDataIrregular = (index, value) => {
    let array = arraySplit;
    let piezas_paq = value;
    if (piezas_paq !== "") {
      let new_value = parseInt(value)
      let total = array[index].split.reduce((acumulador, valorActual) => acumulador + valorActual, 0);
      let rest = array[index].cantidad - total
      if (rest > 0) {
        if (new_value > rest) {
          array[index].split.push(array[index].cantidad - total)
          setRestante(0)
        } else {
          array[index].split.push(new_value);
          setRestante(array[index].cantidad - (total + new_value))
        }
      }
    }
    formData.current[`total_cantidad_irr_${index}`].value = "";
    setArraySplit([...array])
  };

  const deletePaqueteIrr = (index, index_split) => {
    let array = arraySplit;
    let splits = array[index].split
    setRestante(restante + splits[index_split])
    splits.splice(index_split, 1);
    setArraySplit([...array]);
  };




  return (
    <>
      <Grid container spacing={0} sx={{ width: '100%', border: `2px solid ${item?.isCuarentena || item?.isExterno ? "rgb(150, 1, 1)" : "#D9D9D9"}`, borderRadius: 5, mb: 3 }}>
        <Grid item xs={12} sx={{ p: 1 }} className="center_item">
          <Grid container spacing={0}>
            <Grid item xs={6} sm={6} md={4} lg={2} xl={2} sx={{ p: 1 }} className="center_item">
              <TextField
                id={`cantidad_${index}`}
                size="small"
                label="Cantidad"
                fullWidth
                required
                defaultValue={index === 0 ? item.cantidad : ''}
                onKeyDown={(e) => validateNumber(e)}
                onKeyUp={(e) => changeCantidad(index, e.target.value)}
                sx={{ color: theme.palette.primary.input }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={2} xl={2} sx={{ p: 1, flexDirection: 'column', gap: 2 }} className="center_item">
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-alm">Almacén</InputLabel>
                <Select
                  labelId="demo-simple-select-alm"
                  id="alma_id"
                  name="alma_id"
                  label="Almacén"
                  required
                  value={parseInt(item?.almacen)}
                  onChange={(e) => changeOtherData(index, 'almacen', parseInt(e.target.value))}
                  disabled={!item?.isCuarentena && !item?.isExterno}
                >
                  {
                    almacenesCuarentena?.map((alm) => (
                      <MenuItem value={alm?.id}>{alm?.label}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            {
              !item?.isExterno &&
              <Grid item xs={6} sm={6} md={4} lg={2} xl={2} sx={{ p: 1 }} className="center_item">
                <FormGroup>
                  <FormControlLabel control={
                    <Checkbox
                      checked={!item?.isCuarentena}
                      onChange={(e) => changeOtherData(index, 'isCuarentena', !e.target.checked)}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  } label="Enviar a Ruta" />
                </FormGroup>
              </Grid>
            }{
              item?.isExterno &&
              <Grid item xs={6} sm={6} md={4} lg={2} xl={2} sx={{ p: 1 }} className="center_item">
                <FormGroup>
                  <FormControlLabel control={
                    <Checkbox
                      checked={!item?.isExterno}
                      onChange={(e) => changeOtherData(index, 'isExterno', !e.target.checked)}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  } label="Enviar a Ruta" />
                </FormGroup>
              </Grid>
            }
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ p: 1 }} className="center_item">
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              sx={{
                p: 1,
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                flexDirection: "column",
              }}
            >
              <FormControl fullWidth size="small" sx={{ width: "100%" }}>
                <InputLabel id="select-split">Tipo registro</InputLabel>
                <Select
                  labelId="select-split"
                  id="tipo_spliteo"
                  name="tipo_spliteo"
                  label="Tipo Spliteo"
                  value={item?.tipoSplit}
                  onChange={(e) => changeTipoSplit(index, parseInt(e.target.value))}
                  required
                >
                  <MenuItem value={1}>Regular</MenuItem>
                  <MenuItem value={2}>Irregular</MenuItem>
                </Select>
              </FormControl>
              {item?.tipoSplit === TipoSplitEnum.REGULAR && (
                <>
                  <TextField
                    id={`total_contenedores_${index}`}
                    name={`total_contenedores_${index}`}
                    size="small"
                    label="N° de Contenedores"
                    fullWidth
                    required
                    onKeyDown={(e) => validateNumber(e)}
                    onKeyUp={(e) => fillDataRegular(index, e.target.value)}
                    disabled={item?.cantidad === null}
                    sx={{ color: theme.palette.primary.input, width: "100%" }}
                  />
                </>
              )}
              {item?.tipoSplit === TipoSplitEnum.IRREGULAR && (
                <>
                  <TextField
                    id={`total_cantidad_irr_${index}`}
                    size="small"
                    label="Cantidad"
                    fullWidth
                    required
                    disabled={item?.cantidad === null}
                    onKeyDown={(e) => validateNumber(e)}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        fillDataIrregular(index, e.target.value);
                      }
                    }}
                    sx={{ color: theme.palette.primary.input, width: "100%" }}
                  />
                  <span key={`rest_${restante}`}>Restante: {restante} </span>
                </>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={8}
              xl={8}
              sx={{
                p: 1,
                gap: 2,
                height: "100%",
                display: "flex",
                alignItems: "flex-start",
                border: "1px solid #D9D9D9",
                borderRadius: 5,
              }}
            >
              <Grid
                container
                spacing={0}
                sx={{
                  p: 1,
                  textAlign: "start",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {item?.split?.map((paq, index_split) => (
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={4}
                    lg={3}
                    xl={3}
                    sx={{
                      p: 1,
                      textAlign: "start",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Chip
                      label={
                        <div
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              marginRight: 7,
                              fontSize: 14,
                              fontWeight: 400,
                              color: item?.tipoSplit === TipoSplitEnum.REGULAR &&
                                item.split.length > index_split + 1 &&
                                paq !== item.split[index_split + 1] ?
                                "#F57C00" : "black"
                            }}
                          >
                            {paq}
                          </span>
                          <span
                            style={{
                              marginLeft: 7,
                              border: "none",
                              borderRadius: 4,
                              fontSize: 11,
                              padding: 3,
                              color: "#575E3B",
                            }}
                          >
                            {""}
                          </span>
                        </div>
                      }
                      variant="outlined"
                      deleteIcon={
                        item?.tipoSplit === TipoSplitEnum.IRREGULAR ? (
                          <Delete sx={{ marginLeft: "18px !important" }} />
                        ) : null
                      }
                      onDelete={
                        item?.tipoSplit === TipoSplitEnum.IRREGULAR
                          ? () => deletePaqueteIrr(index, index_split)
                          : null
                      }
                      sx={{
                        height: 40,
                        borderRadius: 2,
                        display: "flex",
                        justifyContent:
                          item?.tipoSplit === TipoSplitEnum.IRREGULAR
                            ? "flex-end"
                            : "center",
                        width: "100%",
                        backgroundColor: "transparent",
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )

}